import { HttpClient, HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
//import { TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Constants } from './core/Constants';
import { API_CMS_ENDPOINT, API_ENDPOINT, API_MYM_ENDPOINT, BRAND, getCurrentEndpoint, setAppInjector } from './core/DI';
//import { PackageBuilderService } from './package-builder/package-builder.service';
import { ErrorComponent } from './shared/error/error.component';
import { FilterService } from './shared/filter.service';
import { HardwareService } from './shared/hardware.service';
import { Helper } from './shared/helper';
import { MakeYearModelService } from './shared/make-year-model.service';
import { ProductNotesService } from './shared/notes/product-notes.service';
import { PagingService } from './shared/paging.service';
import { SearchTextService } from './shared/search-text.service';
import { SharedModule } from './shared/shared.module';
import { TireService } from './shared/tire.service';
import { TranslateHttpLoaderJSONC } from './shared/translate-http-loader-jsonc';
import { WheelService } from './shared/wheel.service';
import { ModalService } from './shared/modal-service/modal.service';
import { ProductWarningNotesComponent } from './shared/notes/product-warning-notes/product-warning-notes.component';
import { ProductCustomerSizeComponent } from './shared/products/product-customer-size/product-customer-size.component';
import { ProductCustomerSizeService } from './shared/notes/product-customer-size.service';
import { AddToCartService } from './shared/add-to-cart.service';
import { FileService } from './shared/file.service';
import { GoogleAnalyticsService } from './shared/google-analytics.service';
import { TirePressureLabelComponent } from './placard-tool/tire-pressure-label/tire-pressure-label.component';
import { DefaultUrlSerializer, UrlTree, UrlSerializer } from '@angular/router';
import { PackageKitService } from './shared/packagekit.service';
import { SettingService } from './shared/setting.service';
//import { WheelServiceMock } from '../shared/mocks/wheel.service-mock';
//import { ProductZoomService } from '../shared/notes/product-zoom.service';
import { SeasonalCarePlanModalComponent } from 'app/shared/products/seasonal-care-plan-modal/seasonal-care-plan-modal.component';

export function HttpLoaderFactory(http: HttpClient) {
  // djb:prefix and suffix moved to method
  //return new TranslateHttpLoaderJSONC(http, '/Fastco/js/ngHome/assets/i18n/', '.jsonc');
  return new TranslateHttpLoaderJSONC(http);
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    ProductWarningNotesComponent,
    ProductCustomerSizeComponent,
    TirePressureLabelComponent
  ],
  entryComponents: [ProductWarningNotesComponent, ProductCustomerSizeComponent, TirePressureLabelComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    MatProgressSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    // djb:ng-upgrade-no longer needed, injected and tree shakable
    //NgbModule.forRoot(),
    NgbModule,
    // djb:warn-circular reference discovered when updating 1.2.7 to 1.7.4
    SharedModule,
    FormsModule
  ],
  providers: [
    WheelService,
    // { provide: WheelService, useClass: WheelServiceMock }, // Testing purpose
    MakeYearModelService,
    FilterService,
    PagingService,
    SearchTextService,
    TireService,
    HardwareService,
    PackageKitService,
    //PackageBuilderService,
    ProductNotesService,
    //ProductZoomService,
    ProductCustomerSizeService,
    AddToCartService,
    SettingService,
    FileService,
    GoogleAnalyticsService,
    ModalService,
    { provide: BRAND, useFactory: Helper.getCurrentSiteBrand },
    { provide: API_ENDPOINT, useFactory: getCurrentEndpoint },
    { provide: API_MYM_ENDPOINT, useValue: Constants.API_ENDPOINT },
    { provide: API_CMS_ENDPOINT, useValue: Constants.API_CMS_ENDPOINT },
    // djb:ng8-ref: https://github.com/angular/angular-cli/issues/14587
    //{ provide: APP_BASE_HREF, useValue: '/' + (window.location.pathname.split('/')[1] || '') }
    // djb:warn-messes up routing if set improperly
    //{ provide: APP_BASE_HREF, useValue: '.' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector, private gaService: GoogleAnalyticsService) {
    setAppInjector(this.injector);
    gaService.ensureInit();
  }
}
// djb:may be required for AOT compilation
//export function HttpLoaderFactory(http: HttpClient) {
//  return new TranslateHttpLoader(http);
//}

